module.exports = __webpack_public_path__ + "static/img/Model picture8.b75053b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/3Dmodeling/Model picture8.gif
// module id = EBd7
// module chunks = 1